import Typography from '@mui/material/Typography'
import { FormattedMessage, useIntl } from 'react-intl'
import { PaymentSteps } from '../../../app/paymentSteps'
import MoovyLink from '../../../components/moovyLink'
import usePaymentStep from '../../../hooks/usePaymentStep'
import useUserEmail from '../../../hooks/useUserEmail'

const Success = () => {
  const intl = useIntl()
  const [_currentPaymentStep, setCurrentPaymentStep] = usePaymentStep()
  const [userEmail] = useUserEmail()
  return (
    <>
      <Typography variant="h2">
        <FormattedMessage id="page.webPayment.stepFinish.info.success" />
      </Typography>
      <Typography>
        <FormattedMessage
          id="page.webPayment.stepFinish.info.receipt"
          values={{ email: userEmail }}
        />
      </Typography>

      <MoovyLink.Link
        onClick={(event) => {
          event.preventDefault()
          setCurrentPaymentStep(PaymentSteps.FILL_LICENSE_PLATE)
        }}
        bold
        href="#"
        showArrowForward
      >
        <FormattedMessage id="page.webPayment.stepFinish.button.newPayment" />
      </MoovyLink.Link>
      <MoovyLink.Link
        href={intl.formatMessage({ id: 'facility.webpage.url' })}
        bold
        showArrowForward
      >
        <FormattedMessage id="page.webPayment.stepFinish.backToFacilitySiteButtonText" />
      </MoovyLink.Link>
    </>
  )
}

export default Success
